<template>
	<v-container class="pt-10">
		<div v-if="!getOrderResult.isError">
			<v-row class="d-flex justify-center pb-5">
				<h3>{{ $t('orderconfirmation.ordersend') }}</h3>
			</v-row>
			<v-row class="d-flex justify-center pb-5">
				<div>
					<p class="mb-0 text-center">
						{{ $t('orderconfirmation.textemailsend') }}
						<br />
						{{ $t('orderconfirmation.textdownloadnext') }}
					</p>
				</div>
			</v-row>
			<v-row class="d-flex justify-center pb-2">
				<v-btn text outlined @click="handleDownloadTickets">
					<span class="mr-2 pl-2 fcolor-dark">
						<v-icon class="fcolor-dark">mdi-download </v-icon> {{ $t('orderconfirmation.downloadtickets') }}
					</span>
				</v-btn>
			</v-row>
			<v-row class="d-flex justify-center pb-10" v-if="discountCards.length">
				<v-col class="d-flex justify-center" v-for="card in discountCards" :key="card.pk">
					<v-btn text outlined @click="() => handleDownloadCard(card)">
						<span class="mr-2 pl-2 fcolor-dark">
							<v-icon class="fcolor-dark">mdi-book-open-page-variant-outline </v-icon> {{ card.description }}
						</span>
					</v-btn>
				</v-col>
			</v-row>
			<!--
			<v-row class="d-flex justify-center">
				<v-col cols="12" class="d-flex justify-center">
					<p>{{ $t('orderconfirmation.textnotemail') }}</p>
					<a href="https://www.feriavalencia.com/" target="_blank" class="pl-1 text-decoration-none info--text">{{
						$t('orderconfirmation.textsendagain')
					}}</a>
				</v-col>
			</v-row>
			-->
		</div>
		<div v-else>
			<v-row class="d-flex justify-center pb-5">
				<div>
					<h3 class="mb-0 text-center">{{ getOrderResult.messageError }}</h3>
					<p class="mb-0 text-center" v-if="getOrderResult.purchaseReference">
						{{ $t('orderconfirmation.referenceNumberText') }}
					</p>
					<p class="mt-1 text-center" v-if="getOrderResult.purchaseReference">{{ getOrderResult.purchaseReference }}</p>
				</div>
			</v-row>
		</div>
	</v-container>
</template>

<script>
import api from '../../../api/api';
import { mapGetters } from 'vuex';

export default {
	data() {
		return {
			discountCards: []
		};
	},
	computed: {
		...mapGetters(['getOrderResult', 'getEvent'])
	},
	methods: {
		handleDownloadTickets() {
			const purchaseReference = this.getOrderResult.purchaseReference;
			return api.externalSale
				.downloadTickets({ id: purchaseReference })
				.then((res) => {
					const link = document.createElement('a');
					// create a blobURI pointing to our Blob
					link.href = URL.createObjectURL(res.data);
					link.download = 'Tickets.zip';
					// some browser needs the anchor to be in the doc
					document.body.append(link);
					link.click();
					link.remove();
				})
				.catch((err) => {
					console.log(err);
				});
		},
		handleDownloadCard(card) {
			const params = {
				eventId: this.getEvent.evenid,
				pk: card.id
			};

			return api.event
				.donwloadDocumentDiscountCard({ params })
				.then((res) => {
					const link = document.createElement('a');
					link.href = window.URL.createObjectURL(new window.Blob([res.data]));
					link.download = card.filenameorig;

					console.log(res);

					// link.download = 'Tickets.zip';
					// some browser needs the anchor to be in the doc
					document.body.append(link);
					link.click();
				})
				.catch((err) => {
					console.log(err);
				});
		}
	},
	mounted() {
		setTimeout(function () {  
			const scrollableDiv = document.querySelector('.confirm-order');
			if (scrollableDiv) {
				scrollableDiv.scrollIntoView({ block: 'end' });
			}
		}, 50)
		const params = {
			eventId: this.getEvent.evenid
		};
		api.event
			.getEventDiscountCards({ params })
			.then((res) => {
				this.discountCards = res.data;
			})
			.catch((err) => {
				console.log(err);
			});
	}
};
</script>

<style></style>
